import React from "react";
import { Link } from "react-router-dom";
import { ArrowUpRightIcon } from "lucide-react";
import { images, programme } from "../../data/site";
export function ProgrammeSection() {
  return <section className="mx-auto max-w-[1320px] px-5 py-24 md:px-10 md:py-32" aria-labelledby="programme-title" data-id="element-104" data-mp="2ucfl8si5fs3x">
      <div className="grid gap-12 lg:grid-cols-12 lg:gap-16" data-id="element-105" data-mp="2zca90n6mo1kr">
        <div className="lg:col-span-5" data-id="element-106" data-mp="34b4rtp4lhq4v">
          <h2 id="programme-title" className="font-serif text-4xl leading-[1.1] md:text-6xl" data-id="element-107" data-mp="34a22vmqu1xrl">
            Trois jours <span className="italic" data-id="element-108" data-mp="398wv1faowyod">sous les voiles.</span>
          </h2>
          <p className="mt-6 text-lg leading-relaxed text-navy-soft" data-id="element-109" data-mp="3e0elvaj01ivm">
            Pilotes du monde entier, familles et habitants : le week-end anniversaire est ouvert à tous, que vous voliez ou non.
          </p>
          <img src={images.festival} alt="Des dizaines de parapentes au-dessus d'une prairie où le public regarde" className="mt-10 aspect-[3/2] w-full rounded-[28px] object-cover" data-id="element-110" data-mp="3n2nt9riz0w4s" />
        </div>

        <div className="lg:col-span-7" data-id="element-111" data-mp="168fmb4tbdqxu">
          <ul className="divide-y divide-navy/15 border-y border-navy/15" data-id="element-112" data-mp="1662xq8t1wibt">
            {programme.map(day => <li key={day.day} className="grid gap-4 py-8 md:grid-cols-[180px_1fr] md:gap-8" data-id="element-113" data-mp="11bfhsyc44w8u">
                <div data-id="element-114" data-mp="x9c4031z1fke">
                  <p className="text-sm font-medium uppercase tracking-wide text-wing" data-id="element-115" data-mp="s8o750r2a4i9">{day.day}</p>
                  <p className="font-serif text-4xl" data-id="element-116" data-mp="1oyf7hgm1alvz">{day.date}</p>
                </div>
                <div data-id="element-117" data-mp="1kx26bjtvz6ve">
                  <h3 className="text-xl font-semibold" data-id="element-118" data-mp="1kwtoremtjddv">{day.title}</h3>
                  <ul className="mt-3 space-y-2 text-navy-soft" data-id="element-119" data-mp="1g6dajsb6bnqg">
                    {day.items.map(item => <li key={item} className="flex gap-3" data-id="element-120" data-mp="1b7sbhw7nra3l">
                        <span className="mt-[10px] h-1 w-1 shrink-0 rounded-full bg-navy/40" aria-hidden="true" data-id="element-121" data-mp="1b562rt916ojs" />
                        {item}
                      </li>)}
                  </ul>
                </div>
              </li>)}
          </ul>
          <div className="mt-8 flex flex-wrap items-center justify-between gap-4" data-id="element-122" data-mp="2msq06rju1rk1">
            <p className="text-sm text-navy-soft" data-id="element-123" data-mp="2rpy901j3cj8m">Programme provisoire, susceptible d'évoluer selon la météo.</p>
            <Link to="/programme" className="group inline-flex items-center gap-3 rounded-full bg-navy py-2 pl-6 pr-2 font-semibold text-cream transition-colors duration-150 hover:bg-navy-soft" data-id="element-124" data-mp="2dzcx4ws219k8">
              Programme détaillé
              <span className="flex h-9 w-9 items-center justify-center rounded-full bg-lime text-navy transition-transform duration-150 group-hover:rotate-45" data-id="element-125" data-mp="2441ieegnc2ch">
                <ArrowUpRightIcon className="h-4 w-4" data-id="element-126" data-mp="1v2bp1337etc2" />
              </span>
            </Link>
          </div>
        </div>
      </div>
    </section>;
}